<template>
  <span class="copy-text-wrapper d-inline-flex align-items-center copytext-inlineblock">
    <span ref="content" class="copy-text-content">
      <slot>{{ text }}</slot>
    </span>
    <b-button
      variant="link"
      size="sm"
      class="copy-text-btn p-0 ml-1"
      @click="copyToClipboard"
    >
      <i class="fa fa-copy" style="font-size: 0.75rem;"></i>
    </b-button>
  </span>
</template>

<script>
export default {
  name: 'CopyText',
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    }
  },
  methods: {
    copyToClipboard() {
      const textToCopy = this.text.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            this.$bvToast.toast('Copied <'+textToCopy+'> to clipboard!', {
              title: 'Success',
              variant: 'info',
              solid: true,
              autoHideDelay: 600
            });
          })
          .catch(err => {
            console.error('Failed to copy:', err);
            this.$bvToast.toast('Failed to copy to clipboard', {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 3000
            });
          });
      } else {
        this.$bvToast.toast('Your browser does not support this action!', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        });
      }
    }
  }
};
</script>